import React from "react";
import { Link as MuiLink } from "@mui/material";
import { DataCardShell } from "../../../../../components/responsive";
import Helpers from "../../../../../utils/helpers";
import type { LifecycleRetreat } from "../../../../../types/retreatLifecycle";
import {
  formatLanguage,
  formatRetreatDateRange,
  statusChip,
} from "../../lifecycle/lifecycleUi";
import { retreatDisplayTitle, retreatLocationLine } from "../manageRetreatTypes";
import { SectionActionButtons } from "../SectionActionButtons";

export function DeletedRetreatCard({
  r,
  isSuperAdmin,
  onHistory,
  onDelete,
  onApprove,
  onRestore,
}: {
  r: LifecycleRetreat;
  isSuperAdmin: boolean;
  onHistory: (r: LifecycleRetreat) => void;
  onDelete: (r: LifecycleRetreat) => void;
  onApprove: (r: LifecycleRetreat) => void;
  onRestore: (r: LifecycleRetreat) => void;
}) {
  return (
    <DataCardShell
      title={retreatDisplayTitle(r)}
      subtitle={retreatLocationLine(r) || undefined}
      chips={statusChip("Deleted")}
      fields={[
        { label: "Retreat Id", value: String(r.id ?? "—") },
        { label: "Language", value: formatLanguage(r.language) },
        {
          label: "Location",
          value: r.location
            ? `${r.location.charAt(0).toUpperCase()}${r.location.slice(1)}`
            : "—",
        },
        {
          label: "Dates",
          value: formatRetreatDateRange(r.dateFrom, r.dateTo),
        },
        {
          label: "# Retreatants",
          value: (
            <MuiLink
              href={`/retreatRoster?retreatId=${r.id}&flag=1`}
              onClick={(e) => {
                e.preventDefault();
                window.open(`/retreatRoster?retreatId=${r.id}&flag=1`, "_blank");
              }}
            >
              {r.countRetreatant ?? 0}
            </MuiLink>
          ),
        },
        {
          label: "# Teams",
          value: (
            <MuiLink
              href={`/retreatRoster?retreatId=${r.id}&flag=2`}
              onClick={(e) => {
                e.preventDefault();
                window.open(`/retreatRoster?retreatId=${r.id}&flag=2`, "_blank");
              }}
            >
              {r.countTeam ?? 0}
            </MuiLink>
          ),
        },
        {
          label: "Created",
          value: Helpers.convertUtcToTimezone(
            r.createdAt || "",
            "MM-DD-YYYY hh:mm:a",
          ),
        },
      ]}
      secondaryActions={
        <SectionActionButtons
          r={r}
          kind="deleted"
          isSuperAdmin={isSuperAdmin}
          onHistory={onHistory}
          onDelete={onDelete}
          onApprove={onApprove}
          onRestore={onRestore}
        />
      }
    />
  );
}
